import { pointers } from '@wix/thunderbolt-becky-types'
import type { DataMapName } from '@wix/thunderbolt-becky-types'
import type { ConsumptionDataNode } from './dataNodes/utils/dataNodeUtils'
import type { ByRefsisConsumptionCompNode } from '../../compNodeUtils'
import { Connections } from './dataNodes/Connections'
import { Slots } from './dataNodes/Slot'
import { DocumentData } from './dataNodes/DocumentData'
import { Properties } from './dataNodes/Properties'
import { LayoutData } from './dataNodes/LayoutData'
import { ThemeData } from './dataNodes/ThemeData'
import { DesignData } from './dataNodes/DesignData'
import { Presets } from './dataNodes/Presets'
import { TransformationData } from './dataNodes/TransformationData'
import { Variables } from './dataNodes/Variables'
import { structure } from './compNodes/structure'
import { Patterns } from './dataNodes/Patterns'
import { isGhostComponent } from './compNodes/isGhostComponent'
import { RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT, STRUCTURE_ASPECT } from '../../constants'
import { Variants } from './dataNodes/VariantsData'
import { TransitionData } from './dataNodes/TransitionData'
import { Reactions } from './dataNodes/Reactions'
import { Triggers } from './dataNodes/Triggers'
import { Effects } from './dataNodes/Effects'
import { States } from './dataNodes/States'
import { Behaviors } from './dataNodes/Behaviors'
import { Classnames } from './dataNodes/Classnames'

const {
	DATA_MAPS: {
		CONNECTIONS,
		CLASSNAMES,
		SLOTS,
		DATA,
		PROPERTIES,
		LAYOUT,
		STYLE,
		VARIABLES,
		TRANSFORMATIONS,
		VARIANTS,
		TRANSITIONS,
		REACTIONS,
		TRIGGERS,
		PRESETS,
		PATTERNS,
		EFFECTS,
		STATES,
		BEHAVIORS,
		DESIGN,
	},
} = pointers.data

export const consumptionDataNodes: { [dataMapName in DataMapName]?: ConsumptionDataNode<any, any, any> } = {
	[CONNECTIONS]: Connections,
	[CLASSNAMES]: Classnames,
	[SLOTS]: Slots,
	[DATA]: DocumentData,
	[PROPERTIES]: Properties,
	[LAYOUT]: LayoutData,
	[STYLE]: ThemeData,
	[DESIGN]: DesignData,
	[VARIABLES]: Variables,
	[PRESETS]: Presets,
	[PATTERNS]: Patterns,
	[TRANSFORMATIONS]: TransformationData,
	[VARIANTS]: Variants,
	[TRANSITIONS]: TransitionData,
	[REACTIONS]: Reactions,
	[TRIGGERS]: Triggers,
	[EFFECTS]: Effects,
	[STATES]: States,
	[BEHAVIORS]: Behaviors,
}

export const consumptionCompNodes: Record<string, ByRefsisConsumptionCompNode<any, any>> = {
	[STRUCTURE_ASPECT]: structure,
	[RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT]: isGhostComponent,
}
